import { render, staticRenderFns } from "./GastroErcpList.vue?vue&type=template&id=010b8b00"
import script from "./GastroErcpList.vue?vue&type=script&lang=js"
export * from "./GastroErcpList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports